import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useState, useEffect } from "react";
import { crearProvincia } from "../../../services/provincia.service";
import { getAllDepartamentos } from "../../../services/departamento.service";
import { ContenedorPageTemplate } from "../../../components/templates/ContenedorPageTemplate";
import { FormHook } from "../../../components/molecules/FormHook";
import { FormDiv } from "../../../components/atoms/FormDiv";
import { SubmitButton } from "../../../components/atoms/SubmitButton";
import { FormInput } from "../../../components/molecules/FormInput";
import { showAlert, showErrorAlert } from "../../../components/molecules/ShowAlert";

export const CrearProvinciaPage = () => {
  const navigate = useNavigate();
  const DIR_ICON_MAT = "img/iconos/titulo de docente (con la pizarra).svg";
  const [estaCargando, setEstaCargando] = useState(false);
  const [departamentos, setDepartamentos] = useState([]);
  const [cargandoDepartamentos, setCargandoDepartamentos] = useState(true);

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    const cargarDepartamentos = async () => {
      try {
        const data = await getAllDepartamentos();
        setDepartamentos(data || []);
      } catch (err) {
        showErrorAlert({ text: "Error al cargar los departamentos" });
      } finally {
        setCargandoDepartamentos(false);
      }
    };

    cargarDepartamentos();
  }, []);

  const submit = async (data) => {
    setEstaCargando(true);
    try {
      await crearProvincia({
        nombre: data.nombre,
        idDepartamento: data.idDepartamento,
      });
      showAlert({
        callback: () => navigate("/provincia"),
      });
    } catch (err) {
      const errorMessage = err.response?.data?.message || "Error al crear la provincia";
      showErrorAlert({ text: errorMessage });
    } finally {
      setEstaCargando(false);
    }
  };

  return (
    <ContenedorPageTemplate dirIcono={DIR_ICON_MAT} titulo="Crear Provincia">
      <FormHook
        handleSubmit={handleSubmit}
        submit={submit}
        className="w-[min(100%,700px)] mx-auto"
      >
        <FormDiv>
          <FormInput
            id="nombre"
            label="Nombre de la Provincia"
            type="text"
            placeholder="Nombre de la provincia"
            register={register}
            validation={{
              required: { value: true, message: "Campo requerido" },
              maxLength: {
                value: 60,
                message: "Súpero la cantidad máxima de 60 caracteres",
              },
              minLength: { value: 1, message: "Mínimo 1 caracter" },
            }}
            error={errors.nombre}
          />
          
          <div className="mb-4">
            <label htmlFor="idDepartamento" className="block text-sm font-medium text-gray-700 mb-2">
              Departamento
            </label>
            {cargandoDepartamentos ? (
              <div className="text-gray-500">Cargando departamentos...</div>
            ) : (
              <select
                id="idDepartamento"
                {...register("idDepartamento", {
                  required: { value: true, message: "Campo requerido" },
                })}
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-theme-blue focus:border-transparent"
              >
                <option value="">Seleccione un departamento</option>
                {departamentos.map((depto) => (
                  <option key={depto.idDepartamento} value={depto.idDepartamento}>
                    {depto.nombre}
                  </option>
                ))}
              </select>
            )}
            {errors.idDepartamento && (
              <span className="text-red-500 text-sm mt-1">
                {errors.idDepartamento.message}
              </span>
            )}
          </div>
        </FormDiv>
        <SubmitButton estaCargando={estaCargando} text="Guardar" />
      </FormHook>
    </ContenedorPageTemplate>
  );
};